import { types} from "mobx-state-tree";

export const ViewFilePicState = types.model('ViewFilePicState', {
  fileImageUrl: types.maybe(types.string)
}).actions(self => ({}))

